import styled from 'styled-components';
import { colorAppSecondaryText } from 'common/styles/palette';
import { latoBoldWeight, headlineSmallFontSize, headlineXsFontSize } from 'common/styles/typography';

import { SuiCheckbox, SuiDropdown } from '@splashthat/sui';

export const PrepopulatedTitle = styled.h3`
    font-weight: ${latoBoldWeight};
    font-size: ${headlineSmallFontSize};
`;

export const DescriptionText = styled.p`
    color: ${colorAppSecondaryText};
    font-size: ${headlineXsFontSize};
`;

export const PrepoulatedHeader = styled.div`
    margin-bottom: 0.5em;
`;

export const SocialRsvpCheckbox = styled(SuiCheckbox)`
    margin-bottom: 0.875em;
`;

export const CheckboxLabel = styled.span`
    font-weight: ${latoBoldWeight};
`;

export const SocialNetworkDropdown = styled(SuiDropdown)`
    margin-bottom: 0.875em;
`;
